import { GRAPH_STYLE, TOTAL_APP_ID, TIMESCALE, TIME_OF_USE, USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW } from "../../constants/common";
import { INSIGHTS_USAGE_CHART_ACTIONS, INSIGHTS_USAGE_FETCHER_ACTIONS } from "../../actions/insightsUsageV2Actions";
import { getDisclaimers, cropYearData, isTouDataPresent } from "../../helpers/UsageDashboardHelper";

let defaultState = {
    isLoading : false,
    apiError : false,
    isChartLoading : true,
    enableLeftArrow : false,
    enableRightArrow : false,
    yearOffset : 0,
    disclaimers : [],
    summary : {},
    insightUsageV2Controls : {
        view : null,
        graphStyle: GRAPH_STYLE.COLUMN,
        mode: TIMESCALE.YEAR,
        selectedAppliance : TOTAL_APP_ID,
        rangeToShow : '',
        timeOfUse : TIME_OF_USE.ALL.type,
        isFixedRatePlan : true,
        isTouDataPresent : false
    },
    insightsUsageV2ChartData : {
        [TIMESCALE.YEAR]:{
            apiResponse : null,
            currentChartOptions : {}
        },
        [TIMESCALE.MONTH]:{
            apiResponse : null,
            currentChartOptions : {},
            isLatestBillingCycle : false
        },
        [TIMESCALE.DAY]:{
            apiResponse : null,
            currentChartOptions : {},
        }
    }
}

const insightsUsageV2Reducer = (state =  Object.assign({}, defaultState), action) => {
    switch (action.type){
        case INSIGHTS_USAGE_CHART_ACTIONS.UPDATE_CONTROL : {
            let mode = action.payload.mode || state.insightUsageV2Controls.mode;
            let view = action.payload.view || state.insightUsageV2Controls.view;
            let data = state.insightsUsageV2ChartData[mode].apiResponse;
            state = {
                ...state,
                insightUsageV2Controls:{
                    ...state.insightUsageV2Controls,
                    ...action.payload
                },
                disclaimers : getDisclaimers(data, mode, view, state.yearOffset)                    
            }
        }
        break;
        case INSIGHTS_USAGE_FETCHER_ACTIONS.FETCH_USAGE_DATA_SUCCESS : {
            let mode = action.payload.mode;
            let enableLeftArrow = false;
            let enableRightArrow = false;
            let response = action.payload.data;
            if(mode !== TIMESCALE.YEAR && response && response.length){
                enableLeftArrow = !response[0].isBoundaryInterval;
                enableRightArrow = !response[response.length - 1].isBoundaryInterval;
            } else if(mode === TIMESCALE.YEAR && response && response.length){
                let data = cropYearData(response, state.yearOffset);
                enableLeftArrow = !data[0].isBoundaryInterval;
                enableRightArrow = !data[data.length - 1].isBoundaryInterval;
            }
            let isLatestBillingCycle = !enableRightArrow;
            state = {
                ...state,
                insightsUsageV2ChartData:{
                    ...state.insightsUsageV2ChartData,
                    [mode] : {
                        ...state.insightsUsageV2ChartData[mode],
                        apiResponse : action.payload.data,
                        isLatestBillingCycle
                    }
                },
                isChartLoading : false,
                enableLeftArrow,
                enableRightArrow,
                disclaimers : getDisclaimers(response, mode, state.insightUsageV2Controls.view, state.yearOffset),
                insightUsageV2Controls:{
                    ...state.insightUsageV2Controls,
                    isFixedRatePlan: action.payload.isFixedRatePlan,
                    isTouDataPresent : isTouDataPresent(response, state.yearOffset, mode)
                }
            }
        }
        break;
        case INSIGHTS_USAGE_FETCHER_ACTIONS.FETCH_USAGE_DATA_FAILURE : {
            state = {
                ...state,
                apiError : true
            }
        }
        break;
        case INSIGHTS_USAGE_FETCHER_ACTIONS.FETCHING_USAGE_DATA : {
            state = {
                ...state,
                isChartLoading : true
            }
        }
        break;
        case INSIGHTS_USAGE_CHART_ACTIONS.UPDATE_ARROWS_STATE: {
            state = {
                ...state,
                ...action.payload
            }
        }
        break;
        case INSIGHTS_USAGE_CHART_ACTIONS.UPDATE_OFFSET : {
            let newOffset = state.yearOffset + action.payload;
            let yearData = state.insightsUsageV2ChartData[TIMESCALE.YEAR].apiResponse;
            let leftArrow = yearData.length > USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW && yearData[yearData.length + newOffset - USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW] && !yearData[yearData.length + newOffset - USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW].isBoundaryInterval;
            let rightArrow = newOffset < 0;
            state = {
                ...state,
                yearOffset : newOffset,
                enableLeftArrow : leftArrow,
                enableRightArrow : rightArrow,
                disclaimers : getDisclaimers(yearData, TIMESCALE.YEAR, state.insightUsageV2Controls.view, newOffset),
                insightUsageV2Controls:{
                    ...state.insightUsageV2Controls,
                    isTouDataPresent : isTouDataPresent(yearData, newOffset, TIMESCALE.YEAR)
                }
            }
        }
        break;
        case INSIGHTS_USAGE_FETCHER_ACTIONS.FETCH_CHART_SUMMARY_SUCCESS : {
            state = {
                ...state,
                summary : action.payload
            }
        }
        break;
        default:
        break;
    }

    return state;
}

export default insightsUsageV2Reducer;